export default {
  /* -------------------------------------------------------------------------- */
  /*                             Collection List State                            */
  /* -------------------------------------------------------------------------- */
  loading: false,
  listLoading: false,
  CollectionRecords: [],
  total: 0,
  FilteredCount: 0,
  /* -------------------------------------------------------------------------- */
  /*                            Create Collection State                           */
  /* -------------------------------------------------------------------------- */
  createLoading: false,
  /* -------------------------------------------------------------------------- */
  /*                             Edit Collection State                            */
  /* -------------------------------------------------------------------------- */
  editLoading: false
}
